import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { BellOff } from "lucide-react";
import { BACKEND_URL } from "@/lib/api";

export default function StopReminders() {
  const { token } = useParams();
  const [state, setState] = useState({ status: "loading" });

  useEffect(() => {
    axios.post(`${BACKEND_URL}/api/nudge/stop/${token}`)
      .then((r) => setState({ status: "done", ...r.data }))
      .catch(() => setState({ status: "error" }));
  }, [token]);

  if (state.status === "loading") return <div className="min-h-screen grid place-items-center bg-[#090A0D]"><div className="jet-loader" /></div>;
  const ok = state.status === "done";
  return (
    <div className="min-h-screen bg-[#090A0D] grid place-items-center px-5" data-testid="stop-reminders-page">
      <div className="lux-card max-w-md w-full p-8 sm:p-10">
        <img src="/brand/logo-silver.png" alt="JetSet Group Inc" className="h-12 w-auto mb-8" />
        <BellOff size={22} className="text-[#C6A55C] mb-4" />
        <h1 className="font-serif-display text-3xl text-white uppercase leading-tight" data-testid="stop-reminders-title">
          {ok ? "Reminders stopped" : "Link not valid"}
        </h1>
        <p className="text-sm text-zinc-400 mt-4 leading-relaxed" data-testid="stop-reminders-message">
          {ok
            ? `You won't get any more daily follow-up reminders for "${state.title}"${state.client_name ? ` (${state.client_name})` : ""}${state.trip_ref ? ` on ${state.trip_ref}` : ""}. You can turn them back on from the trip page.`
            : "This link is no longer valid. You can manage follow-up reminders from the trip page."}
        </p>
        <Link to="/" className="frame-btn gold mt-8 inline-flex" data-testid="stop-reminders-portal-link">Go to the portal</Link>
      </div>
    </div>
  );
}
